import React from "react";
import Whychooseus from "../../Components/Layout/Home/Whychooseus";
import Middlebanner from "../../Components/Layout/Home/Middlebanner";
import Partners from "../../Components/Layout/Home/Partners";
import Downloadfromplaystore from "../../Components/Layout/Home/Downloadfromplaystore";
import BackgroundSwiper from "../../Components/Layout/Home/Swipe";
import "../../../src/App.css";
import GpsService from "../../Components/Layout/Home/GpsService";
import WhatsAppIcon from "../Common/WhatsappIcon";

// import Swipercomponent from '../../Components/Layout/Home/Swipercomponent'

const Home = () => {
  return (
    <div>
      {/* <Swipercomponent/> */}
      <WhatsAppIcon />
      <BackgroundSwiper />
      <Whychooseus />
      <Middlebanner />
      <GpsService />
      <Partners />
      <Downloadfromplaystore />
    </div>
  );
};

export default Home;
